import { t } from '../../i18n.jsx';

export default function extractApiErrorMessage(error) {
  if (!error) return t('Neznáma chyba.');

  if (typeof error === 'string') {
    return error;
  }

  if (
    typeof error === 'object' &&
    error.success === false &&
    typeof error.message === 'string'
  ) {
    return error.message;
  }

  const data = error?.data || error?.response?.data;

  if (!data) return t('Neznáma chyba.');

  if (typeof data.validation === 'object') {
    const allMessages = Object.values(data.validation).flat();
    if (allMessages.length > 0) return allMessages[0];
  }

  if (typeof data.errors === 'object') {
    const allMessages = Object.values(data.errors).flat();
    if (allMessages.length > 0) return allMessages[0];
  }

  if (typeof data.message === 'string' && data.message.trim() !== '')
    return data.message;
  if (typeof data.error === 'string' && data.error.trim() !== '')
    return data.error;
  if (typeof error.message === 'string' && error.message.trim() !== '')
    return error.message;

  return t('Nastala neočakávaná chyba.');
}
